import React from "react";
import styled, { css } from "styled-components";
import Img from "../Img/Img";

const LogoWrapper = styled.div`
  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth}px;
      margin-left: 20px;

      > img {
        max-width: 100%;
      }
    `};

  ${(props) =>
    props.full &&
    css`
      width: 100%;
      img {
        width: 100%;
      }
    `};
`;

class ImageWrapper extends React.Component {
  render() {
    const { src, alt, ...props } = this.props;

    return (
      <LogoWrapper {...props}>
        <Img src={src} alt={alt} />
      </LogoWrapper>
    );
  }
}

ImageWrapper.propTypes = {};

export default ImageWrapper;
